import DelayEffect from "./DelayEffect";

export default DelayEffect;
